import Tooltip from '@/ui/Tooltip'
import { Fragment } from 'react'
import { BranchOptionSecondaryButton } from './BranchOptionSecondaryButton'
import { PrimaryButton2ChoicesTwo } from './PrimaryButton2ChoicesTwo'
import { playbookBranchOptionModel } from './playbookBranchOptionModel'
import { getOptionsGridTemplateColumns } from './getOptionsGridTemplateColumns'
import { resolveBranchChoiceDomId } from './resolveBranchChoiceDomId'
import { type PlaybookBranchChoicesGridProps } from './playbookBranchChoicesTypes'

// Desktop layout for binary forks: side-by-side buttons sized like the larger pickers.
export const DesktopPlaybookBranchChoicesTwo = ({
  nodeId,
  options,
  nextNodeId,
  defaultPrimaryTargetId,
  selectedPath,
  currentPathIndex,
  nodes,
  onSelect,
  onPlanHover,
  onBranchHover,
  expandedPlanLayout,
  onGridMouseLeave,
  showPrimaryHoverStyleByDefault,
}: PlaybookBranchChoicesGridProps) => {
  const branchChoiceElementId = resolveBranchChoiceDomId(nodeId)
  const gridTemplateColumns = getOptionsGridTemplateColumns(options, nodes, expandedPlanLayout)
  return (
    <div
      id={branchChoiceElementId}
      data-branch-choice-ids={options.map(o => o.targetId).filter(Boolean).join(',')}
      className="grid gap-2 items-start"
      style={{ gridTemplateColumns }}
      onMouseLeave={onGridMouseLeave}
    >
      {options.map((option) => {
        const optionProps = {
          option,
          isSelected: nextNodeId === option.targetId || defaultPrimaryTargetId === option.targetId,
          selectedPath,
          currentPathIndex,
          nodes,
          onSelect,
          onPlanHover,
          onBranchHover,
          disableTooltip: expandedPlanLayout,
        }
        const { disableTooltip } = optionProps
        const m = playbookBranchOptionModel(optionProps)
        const button = m.isPrimary ? (
          <PrimaryButton2ChoicesTwo
            option={option}
            targetNode={m.targetNode}
            inverted={m.inverted}
            showHoverStyleByDefault={showPrimaryHoverStyleByDefault}
            onClick={m.handleClick}
            onPointerEnter={m.handlePointerEnter}
            onPointerLeave={m.handlePointerLeave}
          />
        ) : (
          <BranchOptionSecondaryButton
            option={option}
            targetNode={m.targetNode}
            inverted={m.inverted}
            onClick={m.handleClick}
            onPointerEnter={m.handlePointerEnter}
            onPointerLeave={m.handlePointerLeave}
          />
        )
        const choiceKey = option.targetId || 'null'
        if (!m.tooltipContent || disableTooltip) {
          return <Fragment key={choiceKey}>{button}</Fragment>
        }
        return (
          <Tooltip key={choiceKey} content={m.tooltipContent}>
            {button}
          </Tooltip>
        )
      })}
    </div>
  )
}
